import { guard, createEffect } from "effector";
import { $userRoles } from "frontend/src/domain/session";
import { $playerCurrentTrackId } from "frontend/src/domain/player-track-queue";
import { trackPlayStatApi } from "frontend/src/api/track-play-stat";
var createTrackPlayStatFx = createEffect(trackPlayStatApi.createOne);
guard({
    source: {
        trackId: $playerCurrentTrackId,
        roles: $userRoles,
    },
    filter: function (data) {
        return (data.trackId !== null && data.roles.business.owner) ||
            data.roles.business.employee;
    },
    target: createTrackPlayStatFx,
});
